import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { catchError, distinctUntilChanged, EMPTY, filter, of, Subscription, tap } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormioCustomComponent, FormioEvent } from '@app/shared/elements.common';
import { AlertService } from '@app/@core/services/alert.service';
import { FormioComponent } from '@formio/angular';
import { FormModalComponent } from '@app/pages/page-designer/form-modal/form-modal/form-modal.component';
import { FormioService, AuthService } from '@pics-core/dynamic';
import { PageBuilderAddService } from '../pagebuilderAddservice';
import { HttpService } from '@app/@core/services/http.service';
import { LocalService } from '@app/@core/services/local.service';
import { DynamicDocumentBridgeService } from '../dynamic-document-bridge.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  standalone: false,
  selector: 'app-custom-grid-list',
  templateUrl: './custom-grid-list.component.html',
  styleUrls: ['./custom-grid-list.component.scss']
})
export class CustomGridListComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy, FormioCustomComponent<any> {
  private static readonly gridStateCache = new Map<string, any>();
  private static readonly formStateCache = new Map<string, any>();

  @Input()
  formId: string;

  @Input()
  set gridId(value: any) {
    this._gridId = this.normalizeGridId(value);
    if (this.isInitialized && this._gridId && this._formattedName) {
      this.loadGridIfReady();
    }
  }
  get gridId(): string {
    return this._gridId;
  }

  @Input()
  query: any;

  @Input()
  fields: any;

  @Input()
  buttonLabel: any;
  @Output() routeTo = new EventEmitter<any>();
  @Input()
  value: any;
  displayMode = 'compact';
  @Output()
  valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  disabled: boolean;

  @Input()
  disableAdd: string;

  @Input()
  name: string;

  @Output()
  formioEvent = new EventEmitter<FormioEvent>();

  @ViewChild('formModal') formModal: ElementRef;

  // @ViewChild('formIO', { static: false })
  // formIO: FormioComponent;
@ViewChild('formIO', { static: false }) formIO: any;
  gridItems: any[] = [];
  gridConfig: any;

  private formData: any = {};

  private BINDING_REGEX = /{\{([0-9A-Za-z_\.\s]+)\}\}/g;

  private bindings = [];

  formJson: any = {};

  modalref: NgbModalRef;

  updateGrid: any;

  isView: boolean;

  customData: any = {};

  primaryColumn: string;

  deleteId: any;

  formName: string;

  isVisible = true;
  isShowForm;
  
  isDisable: boolean;

  loginUserId: number;
  loginUserRoleId: number;
  // isShowMarkAsAddressed: boolean = false;
  // isShowViewDeficiencyNotes: boolean = false;
  // isShowMarkAsValid: boolean = false;
  // isShowMarkAsDeficient: boolean = false;
  actionText: string;
  viewNotesText: any;
  primaryId: any;
  // isShowView: boolean = false;
  // isShowEdit: boolean = true;
  // isShowDelete: boolean = true;
  isActionVisible: boolean = false;
  deleteAction: any;
  gridCustomActions: any = {
    isShowMarkAsAddressed: false,
    isShowViewAddressedNotes: false,
    isShowMarkAsValid: false,
    isShowMarkAsDeficient: false,
    isShowViewDeficiencyNotes: false,
    isShowView: true,
    isShowEdit: true,
    isShowDelete: true
  };
  deficiencyDetails: any = {};

  // validateShowPopup tracking
  validateShowPopup: boolean = true;
  previousValidateShowPopup: boolean = true;
  showRemoveConfirmPopup: boolean = false;
  confirmRemovalCanceled: boolean = false;
  questionLabel: string = '';

  submittedData: any = { data: {} };
  renderOptions: any;
  formOptions = {
    noAlerts: true,
    disableAlerts: true,
    validateOnInit: false,
    validateOnBlur: false
  };
  viewForm: boolean = false;
  noteIdColumn: string;
  noteIdValue: number;

  private _formattedName: string;
  private _gridId: string = '';
  private isInitialized: boolean = false;
  private readonly gridInstanceId = `custom-grid-${Math.random().toString(36).slice(2)}`;
  private readonly subscriptions = new Subscription();
  private gridLoadRequestId = 0;
  private activeGridLoadKey = '';
  private lastCompletedGridLoadKey = '';
  private pendingGridLoadTimer: ReturnType<typeof setTimeout> = null;
  gridConfigLoaded: boolean = false;
  isLoading: boolean = false;
  private feeLookupData: any[] = [];

  @Input() readOnlyCondition: string = '';
  @Input() isDynamicDocumentRequired: boolean | string = false;
  @Input() isTranscriptNeeded: boolean | string = false;
  @Input() isResolveProvisions: boolean | string = false;
  @Input() isResolveRequirement: boolean | string = false;
  readOnly: boolean = false;
  showreadonlydata: boolean = true;
  allGridItems: any[] = [];
  private lastGridOperation = 'load';
  transcriptRowData: any = null;
  transcriptMessage: any = '';
  private pendingTranscriptUpdates = new Set<any>();

  // Resolve Provisions
  resolutionRowData: any = null;
  resolutionNotes: string = '';
  resolutionProvisionValue: string = '';
  resolutionNotesInvalid: boolean = true;
  viewResolutionNotesText: string = '';
  private onDocumentUploaded = (event: any) => {
    const category = String(event?.detail?.category || '').trim();
    console.log('[Transcript Auto] Document uploaded event received, category:', category);
    if (category !== '10') return;
    if (!this.coerceBoolean(this.isTranscriptNeeded)) return;
    console.log('[Transcript Auto] Triggering auto transcript update...');
    this.triggerAutoTranscriptUpdate();
  };
  constructor(
    private readonly pageBuilderService: PageBuilderAddService,
    private readonly formIoService: FormioService,
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly alertService: AlertService,
    private readonly authService: AuthService,
    private sessionStorage: LocalService,
    private readonly httpService: HttpService,
    private readonly dynamicDocumentBridge: DynamicDocumentBridgeService,
    private sanitized: DomSanitizer
  ) {
    // For es lint
  }

  ngOnInit() {
    this.isInitialized = true;

    // Listen for supporting document uploads to auto-update transcript
    window.addEventListener('supporting-document-uploaded', this.onDocumentUploaded);

    this.isDisable = this.disabled? true : false;
    this.formData = this.formIoService.getCurrentFormData();
    this.fetchFeeLookup();
    this.loginUserId = this.sessionStorage.getItem('id') ? Number(this.sessionStorage.getItem('id')) : null;
    this.loginUserRoleId = this.sessionStorage.getItem('role_id') ? Number(this.sessionStorage.getItem('role_id')) : null;
    this.checkReadOnlyMode();
    // Initial evaluation of add condition
    this.evaluateAddCondition();
    this.loadGridIfReady();

    this.subscriptions.add(this.formIoService.getFormData()
      .pipe(
        filter((data) => !!data),
        distinctUntilChanged()
      )
      .subscribe(({ changed, data }) => {
        this.formData = data;
        this.evaluateAddCondition();
        this.checkReadOnlyMode();
        this.checkAutoTranscript(data);
        // this.getGridConfig();

        // Reload only when this grid's query depends on the changed Formio field.
        if (this.isGridQueryBindingChanged(changed?.component?.key)) {
          this.loadGridIfReady();
        }
      }));

    this.updateGrid = {
      edit: !this.disabled,
      editAppeal: true,
      viewRecord: true,
      editRecord: true,
      view: true,
      lock: false,
      duplicate: false,
      delete: !this.disabled,
      externalLink: false,
      rowSelection: true,
      appeal: false
    };
    // console.log('this.gridId ->',this.gridId);
    // this.loginUserId = sessionStorage.getItem('id') ? Number(sessionStorage.getItem('id')) : null;
    // this.loginUserRoleId = sessionStorage.getItem('role_id') ? Number(sessionStorage.getItem('role_id')) : null;
    // this.showCustomAction();
    this.saveDeficiencyDetails();



    // Initialize form related configurations
    this.authService.clearFormAttachments();
    const _component = this;
this.renderOptions = {
    hooks: {
      beforeSubmit: (submission, callback) => {
        const formioInstance = this.formIO?.formio;
        if (formioInstance && !formioInstance.checkValidity(submission.data, true)) {
          this.alertService?.error('Please fill required fields');
          setTimeout(() => {
            (
              document.querySelector(
                'input.is-invalid, select.is-invalid, .selection.is-invalid'
              ) as HTMLElement
            )?.focus();
          }, 500);
          return callback({ message: 'Validation failed' }, submission);
        }
        return callback(null, submission);
      }
    }
  };

    // Initialize auth service
    this.authService.clearFormAttachments();

    // Load the form and initialize grid
    this.getForm().subscribe(() => {
      // Initialize the customData and submittedData
      this.submittedData = {
        data: {
          ...this.customData
        }
      };

      // Try to load grid initially
      this.loadGridIfReady();
    });
  }


  private loadGridIfReady(force = false): void {
    this.debugGrid('loadGridIfReady called', { force });
    // Only load if component is visible and we have necessary data
    if (this.isVisible && this._formattedName && this.gridId) {
      const loadKey = this.getGridLoadKey();
      const cachedState = CustomGridListComponent.gridStateCache.get(loadKey);
      if (!force && cachedState) {
        this.debugGrid('loadGridIfReady using cached grid state', { loadKey });
        this.applyCachedGridState(loadKey, cachedState);
        return;
      }
      if (this.pendingGridLoadTimer) {
        clearTimeout(this.pendingGridLoadTimer);
      }
      this.pendingGridLoadTimer = setTimeout(() => {
        this.pendingGridLoadTimer = null;
        this.debugGrid('loadGridIfReady timer firing', { force, loadKey });
        this.getGridConfig(force);
      }, 0);
    } else {
      this.debugGrid('loadGridIfReady skipped: not ready', {
        hasVisible: this.isVisible,
        hasFormattedName: !!this._formattedName,
        hasGridId: !!this.gridId
      });
    }
  }

  evaluateAddCondition() {
    // this.showCustomAction();
    this.saveDeficiencyDetails();
    const previousIsVisible = this.isVisible;
    const previousIsDisable = this.isDisable;

    if (this.disableAdd) {
      try {
        const addButtonScript = this.disableAdd.replace(/sessionStorage/g, 'sessionStorageService');
        const prefix = 'var disableAddButton = false; var showAddButton = true; var showActionButton = false; var validateshowpopup = true; var questionLabel = \'\'; var showreadonlydata = true; var showForm;';
        const suffix = ';return { disableAddButton: disableAddButton, showAddButton: showAddButton, showActionButton: showActionButton, validateshowpopup: validateshowpopup, questionLabel: questionLabel, showreadonlydata: showreadonlydata, showForm: showForm };';
        const fnDef = new Function('data', 'sessionStorageService', `${prefix}${addButtonScript}${suffix}`);
        const result = fnDef(this.formData || {}, this.sessionStorage);


        this.isVisible = result.showAddButton;
        this.isDisable = result.disableAddButton;
        this.isShowForm = result.showForm;
        this.isActionVisible = result.showActionButton;
        const newShowReadonlyData = result.showreadonlydata !== undefined ? result.showreadonlydata : true;
        if (this.showreadonlydata !== newShowReadonlyData && this.allGridItems.length > 0) {
          this.showreadonlydata = newShowReadonlyData;
          this.gridItems = newShowReadonlyData
            ? [...this.allGridItems]
            : this.allGridItems.filter(item => !this.isGridItemReadOnly(item));
          this.emitGridValueEvent(this.gridItems);
          this.cdr.detectChanges();
        } else {
          this.showreadonlydata = newShowReadonlyData;
        }
        if (result.questionLabel) {
          this.questionLabel = result.questionLabel;
        }

        // Track validateShowPopup changes (using lowercase from script)
        const newValidateShowPopup = result.validateshowpopup !== undefined ? result.validateshowpopup : true;


        // Check if validateShowPopup changed from true to false AND grid has data AND not in post-cancel reset state
        if (this.previousValidateShowPopup === true && newValidateShowPopup === false && this.gridItems && this.gridItems.length > 0 && !this.confirmRemovalCanceled) {
          this.showRemoveConfirmationPopup();
        }

        this.previousValidateShowPopup = newValidateShowPopup;
        this.validateShowPopup = newValidateShowPopup;


        if (!previousIsVisible && this.isVisible && this._formattedName) {
          setTimeout(() => {
            this.loadGridIfReady();
          }, 0);
        }
      } catch (e) {
        console.error('Error evaluating add condition:', e);
        this.isVisible = true;
        this.isDisable = false;
      }
    } else {
      this.isVisible = true;
      this.isDisable = false;
    }

    if (this.checkARLLicenseLimitCondition() || this.disabled ) {
      this.isDisable = true;
    }

    if (!previousIsVisible && this.isVisible && this._formattedName) {
      this.loadGridIfReady();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.debugGrid('ngOnChanges', {
      changedKeys: Object.keys(changes || {}),
      currentGridId: changes.gridId?.currentValue,
      previousGridId: changes.gridId?.previousValue,
      currentFormId: changes.formId?.currentValue,
      currentName: changes.name?.currentValue
    });

    if ('formId' in changes && changes.formId.currentValue) {
      this.getForm().subscribe(() => {
        // Initialize the customData and submittedData
        this.submittedData = {
          data: {
            ...this.customData
          }
        };

        // Try to load grid initially
        this.loadGridIfReady();
      });
    }

    if (changes.name?.currentValue) {
      this._formattedName = changes.name.currentValue.replace(/data\[(.+)\]/, '$1');
      if (this.isVisible && this._formattedName) {
        this.loadGridIfReady();
      }
    }

    if (changes.query && changes.query.currentValue !== changes.query.previousValue) {
      this.setQueryBindings(changes.query.currentValue);
    }

    if (changes.gridId && changes.gridId.currentValue) {
      this.formData = this.formIoService.getCurrentFormData();
      if (this._formattedName) {
        this.loadGridIfReady();
      }
    }

    if (changes.query && changes.query.previousValue !== changes.query.currentValue) {
      this.evaluateAddCondition();
      this.checkReadOnlyMode();
      if (this.isVisible && this._formattedName) {
        this.loadGridIfReady();
      }
    }

    if (changes.disableAdd && changes.disableAdd.previousValue !== changes.disableAdd.currentValue) {
      this.evaluateAddCondition();
    }
    if (changes.readOnlyCondition && changes.readOnlyCondition.previousValue !== changes.readOnlyCondition.currentValue) {
      this.checkReadOnlyMode();
    }
  }

  getNestedProperty(obj, props, defaultValue = null) {
    if (!obj || !props?.length) {
      return defaultValue;
    }
    const [prop, ...rest] = props;
    if (rest.length === 0) {
      return obj[prop] ?? defaultValue;
    }
    return this.getNestedProperty(obj[prop], rest, defaultValue);
  }

  formatDataForQuery(d: unknown): string {
    if (Array.isArray(d)) {
      return d.map(data => this.formatDataForQuery(data)).join(',');
    }
    if (isNaN(d as number) || d === null || d === undefined) {
      return '\'null\'';
    }
    return d as string;
  }

  getQueryCondition() {
    if (!this.query) {
      return '';
    }
    return this.query.replace(this.BINDING_REGEX, (_, p) => {
      const d = this.resolveBindingValue(p);
      return this.formatDataForQuery(d);
    });
  }

  private setQueryBindings(query: any): void {
    const matches = String(query || '').match(this.BINDING_REGEX);
    this.bindings = matches?.length ? matches.map(m => m.replace(/[\{\}]/g, '').trim()) : [];
  }

  private normalizeGridId(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'object') {
      return String(value.id || value.value || value.gridId || '');
    }
    return String(value);
  }

  private isGridQueryBindingChanged(changedKey: string): boolean {
    if (!changedKey || !this.bindings?.length) {
      return false;
    }
    return this.bindings.some(binding =>
      binding === changedKey ||
      binding.startsWith(`${changedKey}.`) ||
      changedKey.startsWith(`${binding}.`) ||
      (binding === 'application_id' && changedKey === 'applicationId') ||
      (binding === 'applicationId' && changedKey === 'application_id')
    );
  }

  private getGridLoadKey(): string {
    return `${this.normalizeGridId(this.gridId)}|${this._formattedName}|${this.getQueryCondition()}`;
  }

  private debugGrid(message: string, extra: any = {}): void {
    const safeQueryCondition = (() => {
      try {
        return this.query ? this.getQueryCondition() : '';
      } catch (error) {
        return `query-error: ${error?.message || error}`;
      }
    })();

    console.log('[CustomGridListDebug]', {
      message,
      gridId: this.gridId,
      normalizedGridId: this.normalizeGridId(this.gridId),
      formId: this.formId,
      name: this.name,
      formattedName: this._formattedName,
      isVisible: this.isVisible,
      isLoading: this.isLoading,
      gridConfigLoaded: this.gridConfigLoaded,
      bindings: this.bindings,
      query: this.query,
      queryCondition: safeQueryCondition,
      formDataApplicationId: this.formData?.application_id,
      formDataApplicationIdCamel: this.formData?.applicationId,
      sessionApplicationId: this.getSessionValue('application_id', 'applicationID', 'applicationId'),
      rows: this.gridItems?.length || 0,
      allRows: this.allGridItems?.length || 0,
      activeGridLoadKey: this.activeGridLoadKey,
      lastCompletedGridLoadKey: this.lastCompletedGridLoadKey,
      ...extra
    });
  }

  private getSessionValue(...keys: string[]): any {
    for (const key of keys) {
      const value = this.sessionStorage.getItem(key);
      if (value === null || value === undefined || value === '') {
        continue;
      }
      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    }
    return null;
  }

  private resolveBindingValue(binding: string): any {
    const key = String(binding || '').trim();
    const dataValue = this.getNestedProperty(this.formData, key.split('.'));
    if (dataValue !== null && dataValue !== undefined && dataValue !== '') {
      return dataValue;
    }
    if (key === 'application_id') {
      return this.formData?.applicationId ?? this.getSessionValue('application_id', 'applicationID', 'applicationId');
    }
    if (key === 'applicationId') {
      return this.formData?.application_id ?? this.getSessionValue('applicationID', 'application_id', 'applicationId');
    }
    if (key === 'person_id') {
      return this.formData?.personId ?? this.getSessionValue('person_id', 'personId');
    }
    return dataValue;
  }

  getGridConfig(force = false) {
    this.debugGrid('getGridConfig called', { force });
    if (this.query?.includes('{{application_id}}') &&
      !this.resolveBindingValue('application_id')) {
    this.debugGrid('getGridConfig skipped: application_id missing');
    return;
  }

    const gridId = this.normalizeGridId(this.gridId);
    if (!this._formattedName || !gridId) {
      console.warn('Grid configuration cannot be loaded: missing required data');
      this.debugGrid('getGridConfig skipped: missing name or gridId');
      return;
    }

    let queryCondition = '';
    queryCondition = this.getQueryCondition();
    const loadKey = this.getGridLoadKey();
    const cachedState = CustomGridListComponent.gridStateCache.get(loadKey);
    if (!force && cachedState) {
      this.debugGrid('getGridConfig using cached grid state', { loadKey });
      this.applyCachedGridState(loadKey, cachedState);
      return;
    }
    if (!force && this.lastCompletedGridLoadKey === loadKey) {
      this.debugGrid('getGridConfig skipped: load key already completed', { loadKey });
      return;
    }
    if (!force && this.isLoading && this.activeGridLoadKey === loadKey) {
      this.debugGrid('getGridConfig skipped: same load already in flight', { loadKey });
      return;
    }
    this.activeGridLoadKey = loadKey;
    this.isLoading = true;
    const requestId = ++this.gridLoadRequestId;
    const withResult = true;
    this.debugGrid('getGridConfig api start', { loadKey, requestId, queryCondition });
    this.pageBuilderService
      .getGridResult(gridId, queryCondition, this._formattedName, withResult)
      .pipe(
        catchError(error => {
          if (requestId !== this.gridLoadRequestId) {
            this.debugGrid('getGridConfig ignored stale error', { requestId });
            return EMPTY;
          }
          console.error('Error loading grid configuration:', error);
          this.debugGrid('getGridConfig api error', { requestId, error });
          this.isLoading = false;
          this.activeGridLoadKey = '';
          this.gridConfig = [];
          this.gridItems = [];
          this.allGridItems = [];
          this.emitGridValueEvent(this.gridItems);
          this.cdr.detectChanges();
          return EMPTY;
        })
      )
      .subscribe((response: any) => {
        if (requestId !== this.gridLoadRequestId) {
          this.debugGrid('getGridConfig ignored stale response', { requestId });
          return;
        }
        this.isLoading = false;
        this.gridConfigLoaded = true;
        this.lastCompletedGridLoadKey = loadKey;
        if (response && response.data) {
          this.debugGrid('getGridConfig api success', {
            requestId,
            columnCount: response.data.page?.gridconfig?.gridConfigFormArray?.length || 0,
            resultCount: response.data.response?.result?.length || 0
          });
          this.gridConfig = response.data.page.gridconfig.gridConfigFormArray.map(c => {
            return {
              ...c,
              columnDef: c.columnDef.split('.').slice(1).join('.'),
              isHtml: c.header?.toLowerCase() === 'notes'
            };
          });

          // Hide "Updated By" column for role ID 405
          if (this.loginUserRoleId === 405) {
            this.gridConfig = this.gridConfig.map(c => {
              if (c.header?.toLowerCase().trim() === 'updated by') {
                return {
                  ...c, hide: true,
                  isHtml: c.header?.toLowerCase() === 'notes'
                };
              }
              return c;
            });
          }
          // Mark the first visible column for star icon display
          const firstVisibleColumnIndex = this.gridConfig.findIndex(c => c.hide !== true);
          if (firstVisibleColumnIndex !== -1) {
            this.gridConfig[firstVisibleColumnIndex].isFirstVisibleColumn = true;
          }

          this.primaryColumn = response.data.page.tableschemaconfig?.tablefields.primary || response.data.page.tableschemaconfig.tablelist[0];

          const results = response.data.response?.result || [];
          this.gridItems = results.map((r, index) => {

            const gridItem = r.row.reduce((obj, d) => {
              if (d.name.includes('.')) {
                const [table, column] = d.name.split('.');
                if (table === this.primaryColumn) {
                  obj[column] = d.value;
                } else {
                  obj[table] = obj[table] || {};
                  obj[table][column] = d.value
                }
              } else {
                obj[d.name] = d.value;
              }
              return obj;
            }, {});

            // Preserve is_read_only and is_new flags from the response
            // Check multiple possible locations where these flags might exist
            if (r.data) {
              gridItem['is_read_only'] = r.data.is_read_only;
              gridItem['is_new'] = r.data.is_new;
            } else if (r.response) {
              gridItem['is_read_only'] = r.response.is_read_only;
              gridItem['is_new'] = r.response.is_new;
            }

            // Also check if flags are directly in the row data
            const isReadOnlyCol = r.row.find(d => d.name === 'is_read_only');
            const isNewCol = r.row.find(d => d.name === 'is_new');
            if (isReadOnlyCol) {
              gridItem['is_read_only'] = isReadOnlyCol.value;
            }
            if (isNewCol) {
              gridItem['is_new'] = isNewCol.value;
            }

            return gridItem;
          });
          const isMatch = Array.isArray(this.formData?.notesPageId) ? this.formData?.notesPageId.includes(this.gridId) : this.gridId === this.formData?.notesPageId;
          if (isMatch && !this.formData?.adrId.includes(this.loginUserRoleId)) {
            if (this.loginUserRoleId == this.formData?.apprId) {
              this.gridItems = this.gridItems.filter(
                item => item?.notes_type === 'Deficiency'
              );
            }
            else if (this.formData?.bgrId.includes(this.loginUserRoleId)) {
              this.gridItems = this.gridItems.filter(
                item =>
                  item?.notes_type === 'Deficiency' ||
                  (item?.notes_type === 'Internal' &&
                    this.formData?.bgrId.includes(item?.created_user_role) &&
                    !this.formData?.adrId.includes(item?.created_user_role)
                  )
              );
            }
            else {
              this.gridItems = this.gridItems.filter(
                item =>
                  item?.notes_type === 'Deficiency' ||
                  (item?.notes_type === 'Internal' &&
                    !this.formData?.bgrId.includes(item?.created_user_role) &&
                    !this.formData?.adrId.includes(item?.created_user_role))
              );
            }
          }
          this.allGridItems = [...this.gridItems];
          this.cacheCurrentGridState();

          // "Updated By" column visibility:
          // - Role 405: Always hidden (handled above)
          // - Other roles: Always visible (even when empty values)

          if (!this.showreadonlydata) {
            this.gridItems = this.gridItems.filter(item => !this.isGridItemReadOnly(item));
          }
          this.gridItems = this.filterDefComments(this.gridItems)
          this.emitGridValueEvent(this.gridItems);
          this.evaluateAddCondition();
          this.calculateApplicationFees();
          this.checkAutoTranscript(this.formData);
          this.cdr.detectChanges();
        } else {
          console.warn('Invalid grid response received');
          this.debugGrid('getGridConfig invalid response', { requestId, response });
          this.gridConfig = [];
          this.gridItems = [];
          this.allGridItems = [];
          this.emitGridValueEvent(this.gridItems);
          this.evaluateAddCondition();
          this.calculateApplicationFees();
          this.cdr.detectChanges();
        }
      });
  }

  getForm() {
    this.debugGrid('getForm called');
    if (!this.formId) {
      this.debugGrid('getForm skipped: formId missing');
      return of(null);
    }
    const cachedFormState = CustomGridListComponent.formStateCache.get(String(this.formId || ''));
    if (cachedFormState) {
      this.debugGrid('getForm using cached form state');
      this.applyCachedFormState(cachedFormState);
      return of(cachedFormState.response);
    }

    return this.pageBuilderService.getFormPage(this.formId).pipe(
      tap(async (response: any) => {
        this.debugGrid('getForm api success', {
          formRows: response?.data?.length || 0
        });
        if (response.data.length) {
          const { template_json, page_name } = response.data[0];
          this.formName = page_name;
          this.formJson = typeof template_json === 'string' ? JSON.parse(template_json) : template_json;
          this.cacheCurrentFormState(response);
          this.onReset();
          await this.getAdditionalFieldValues();
        }
      })
    );
  }

  private applyCachedFormState(cachedFormState: any): void {
    this.formName = cachedFormState.formName;
    this.formJson = this.cloneData(cachedFormState.formJson);
    this.onReset();
    this.getAdditionalFieldValues();
  }

  private cacheCurrentFormState(response: any): void {
    if (!this.formId || !this.formJson) {
      return;
    }
    CustomGridListComponent.formStateCache.set(String(this.formId), {
      formName: this.formName,
      formJson: this.cloneData(this.formJson),
      response
    });
  }

  private cloneData<T>(value: T): T {
    if (value === null || value === undefined) {
      return value;
    }
    try {
      return JSON.parse(JSON.stringify(value));
    } catch {
      return value;
    }
  }

  getAdditionalFieldValues(){
          if (this.fields) {
            const additionalFields = this.fields.replace(this.BINDING_REGEX, (_, p) => {
              const d = this.getNestedProperty(this.formData, p.trim().split('.'));
              return this.formatDataForQuery(d);
            });
            this.customData = additionalFields
              .split(',')
              .map(d => d.trim())
              .reduce((acc, d) => {
                const [key, rawValue] = d.split('=').map(x => x.trim());
                    let value = rawValue;
                    if (value.startsWith('{{') && value.endsWith('}}')) {
                    const inner = value.slice(2, -2).trim();
                    try {
                    if (inner.startsWith('this.sessionStorage.getItem')) {
                      value = this.sessionStorage.getItem(inner.match(/this\.sessionStorage\.getItem\(['"](.+?)['"]\)/)?.[1] || '') || '';
                      }
                    } catch (err) {
                    console.error('Failed to resolve dynamic value:', inner, err);
                  }
                }
                acc[key] = value;
                return acc;
              }, {} as Record<string, any>);
          }
  }

  private getGridItemId(item: any): any {
    if (!item) {
      return null;
    }
    return item[this.primaryColumn] ?? item.primary_id ?? item.id;
  }

  private buildLocalGridItem(formData: any, id?: any): any {
    const gridItem = {
      ...(formData || {}),
      ...(this.customData || {})
    };
    const recordId = id ?? this.getGridItemId(gridItem);
    if (recordId !== null && recordId !== undefined) {
      gridItem.primary_id = recordId;
      gridItem.id = gridItem.id ?? recordId;
      if (this.primaryColumn) {
        gridItem[this.primaryColumn] = gridItem[this.primaryColumn] ?? recordId;
      }
    }
    return gridItem;
  }

  private commitLocalGridItems(items: any[], emitValue = true): void {
    this.allGridItems = [...items];
    this.gridItems = this.showreadonlydata
      ? [...this.allGridItems]
      : this.allGridItems.filter(item => !this.isGridItemReadOnly(item));
    this.gridItems = this.filterDefComments(this.gridItems);
    this.emitGridValueEvent(this.gridItems, emitValue);
    this.cacheCurrentGridState();
    this.cdr.detectChanges();
  }

  private cacheCurrentGridState(): void {
    const cacheKey = this.lastCompletedGridLoadKey || this.activeGridLoadKey;
    if (!cacheKey || !this.gridConfig) {
      return;
    }
    CustomGridListComponent.gridStateCache.set(cacheKey, {
      gridConfig: [...this.gridConfig],
      allGridItems: [...this.allGridItems],
      primaryColumn: this.primaryColumn
    });
  }

  private applyCachedGridState(cacheKey: string, cachedState: any): void {
    this.gridConfig = [...(cachedState.gridConfig || [])];
    this.primaryColumn = cachedState.primaryColumn;
    this.gridConfigLoaded = true;
    this.lastCompletedGridLoadKey = cacheKey;
    this.isLoading = false;
    this.commitLocalGridItems([...(cachedState.allGridItems || [])], false);
    this.evaluateAddCondition();
    this.calculateApplicationFees();
    this.checkAutoTranscript(this.formData);
  }

  private addLocalGridItem(formData: any, id?: any): void {
    const item = this.buildLocalGridItem(formData, id);
    this.commitLocalGridItems([...(this.allGridItems || []), item], false);
  }

  private updateLocalGridItem(formData: any, id?: any): void {
    const recordId = id ?? this.getGridItemId(formData);
    const updatedItem = this.buildLocalGridItem(formData, recordId);
    const currentItems = this.allGridItems?.length ? this.allGridItems : this.gridItems;
    const index = currentItems.findIndex(item => this.getGridItemId(item) == recordId);
    if (index === -1) {
      this.addLocalGridItem(formData, recordId);
      return;
    }
    const nextItems = [...currentItems];
    nextItems[index] = {
      ...nextItems[index],
      ...updatedItem
    };
    this.commitLocalGridItems(nextItems, false);
  }

  private removeLocalGridItem(id: any): void {
    const currentItems = this.allGridItems?.length ? this.allGridItems : this.gridItems;
    this.commitLocalGridItems(currentItems.filter(item => this.getGridItemId(item) != id), false);
  }

  showModal() {
    this.getForm().subscribe(() => {
      this.modalref = this.modalService.open(FormModalComponent, {
        centered: true,
        size: 'xl',
        backdrop: 'static',
        windowClass: 'custom-grid-form-modal'
      });
      this.modalref.componentInstance.title = `Add ${this.formName || ''}`;
      this.modalref.componentInstance.submittedData = {
        data: {
          ...this.customData
        }
      };
      this.modalref.componentInstance.formJson = this.formJson;
      this.modalref.componentInstance.formId = this.formId;
      this.modalref.componentInstance.customData = this.customData;
      this.modalref.componentInstance.viewForm = false;
      this.modalref.componentInstance.gridItems = this.allGridItems.length > 0 ? this.allGridItems : this.gridItems;
      this.modalref.dismissed.pipe(filter(result => !!result)).subscribe((result: any) => {
        // Hard delete the cache to force refresh the list
        this.pageBuilderService.clearCacheByKey(window.btoa(this.getQueryCondition() + '-' + this._formattedName));
        this.confirmRemovalCanceled = false; // Reset on grid data change
        this.lastGridOperation = 'add';
        this.addLocalGridItem({ ...result.submittedData, ...(result.serverData || {}) }, result.resultId);
        setTimeout(() => {
          this.evaluateAddCondition();
          this.calculateApplicationFees();
        }, 100);
      });
    });
  }

  onSave() {
    this.formIO.formio.submit();

  }
  onReset() {
     if (this.formIO && this.formIO.formio) {
      this.formIO.formio.resetValue();
    }
  }

  closePopup() {
    this.actionText = null;
    this.modalService.dismissAll();
  }

  onEdit(data) {
    this.pageBuilderService
      .getMember(data.data[this.primaryColumn] || data.data.primary_id, this.formId)
      .pipe(
        filter((res: any) => res.status === 'success'),
        catchError(error => {
          throw new Error(error);
        })
      )
      .subscribe(res => {
          this.modalref = this.modalService.open(FormModalComponent, {
            centered: true,
            size: 'xl',
            backdrop: 'static',
            windowClass: 'custom-grid-form-modal edit-custom-grid-form-modal'
          });
         // this.modalref.componentInstance.title = `Edit ${this.formName || ''}`;
          let title = `Edit Record`;
          if(this.formData?.customAction && Array.isArray(this.formData?.customAction) && this.formData?.customAction.length > 0){
            const pageActionDetail = this.formData?.customAction.filter(action => action.pageId === this.gridId);
            if(pageActionDetail && pageActionDetail.length > 0 && Object.keys(pageActionDetail[0]).length > 0) {
              title = pageActionDetail[0].editTitle || title;
            }
          }
         const isMatch = Array.isArray(this.formData?.notesPageId) ? this.formData?.notesPageId.includes(this.gridId) : this.gridId === this.formData?.notesPageId;
         this.modalref.componentInstance.title =  (this.formData?.notesActionIcon?.editTitle && isMatch) ?  this.formData?.notesActionIcon?.editTitle : title;
         this.modalref.componentInstance.action = `Update`;
          this.modalref.componentInstance.id = data.data.primary_id;
          this.modalref.componentInstance.submittedData = {
            data: {
              ...res.data,
              ...this.customData
            }
          };
          this.modalref.componentInstance.formJson = this.formJson;
          this.modalref.componentInstance.formId = this.formId;
          this.modalref.componentInstance.customData = this.customData;
          this.modalref.componentInstance.viewForm = false;
          this.modalref.componentInstance.gridItems = this.allGridItems.length > 0 ? this.allGridItems : this.gridItems;
          this.modalref.dismissed.pipe(filter(result => !!result)).subscribe((result: any) => {
            this.confirmRemovalCanceled = false; // Reset on grid data change
            this.lastGridOperation = 'edit';
            this.updateLocalGridItem({ ...result.submittedData, ...(result.serverData || {}) }, data.data[this.primaryColumn] || data.data.primary_id);
            setTimeout(() => {
              this.evaluateAddCondition();
              this.calculateApplicationFees();
            }, 100);
        });
      });
  }

  getRouter(data) {
    this.routeTo.emit(data);
  }

  onDelete(data, deleteModel) {
    console.log('DeleteData ->',data);
    this.deleteAction = {};
    this.deleteId = data.data[this.primaryColumn] || data.data.primary_id;
    this.modalref = this.modalService.open(deleteModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details delete-appointment-details'
    });
    let title = `Delete Record`;
    let content = `Are you sure you want to delete this record? This action cannot be undone.`;
    if(this.formData?.customAction && Array.isArray(this.formData?.customAction) && this.formData?.customAction.length > 0){
       const pageActionDetail = this.formData?.customAction.filter(action => action.pageId === this.gridId);
       if(pageActionDetail && pageActionDetail.length > 0 && Object.keys(pageActionDetail[0]).length > 0) {
         title = pageActionDetail[0].deleteTitle || title;
         content = pageActionDetail[0].deleteContent || content;
      }
    }
    const isMatch = Array.isArray(this.formData?.notesPageId) ? this.formData?.notesPageId.includes(this.gridId) : this.gridId === this.formData?.notesPageId;
    this.deleteAction = {
      title : ((this.formData?.notesActionIcon?.deleteTitle && isMatch) ?  this.formData?.notesActionIcon?.deleteTitle : title),
      content : ((this.formData?.notesActionIcon?.deleteContent && isMatch) ?  this.formData?.notesActionIcon?.deleteContent : content)
    }
  }

  onDeleteItem() {
    this.pageBuilderService
      .deleteRow(this.deleteId, this.formId)
      .pipe(filter((res: any) => res.status === 'success'))
      .subscribe(_ => {
        this.closePopup();
        this.confirmRemovalCanceled = false; // Reset on grid data change
        this.lastGridOperation = 'delete';
        this.removeLocalGridItem(this.deleteId);
        setTimeout(() => {
          this.evaluateAddCondition();
          this.calculateApplicationFees();
        }, 100);
        this.alertService.success("Deleted Successfully.");
      });
  }

  // Show confirmation popup when validateShowPopup changes from true to false
  showRemoveConfirmationPopup() {
    this.showRemoveConfirmPopup = true;
    this.cdr.detectChanges();
  }

  // Close the remove confirmation popup (user canceled)
  closeRemoveConfirmPopup() {
    this.showRemoveConfirmPopup = false;
    this.confirmRemovalCanceled = true;

    // Emit the value with the canceled flag to force radio back to "Yes"
    this.emitGridValueEvent(this.gridItems);

    this.cdr.detectChanges();

    // After Form.io processes and forces radio back to "Yes",
    // reset the flag so the radio re-enables and the popup can trigger again on next "No" click
    setTimeout(() => {
      this.confirmRemovalCanceled = false;
      this.previousValidateShowPopup = true;
      this.emitGridValueEvent(this.gridItems);
      this.cdr.detectChanges();
    }, 500);
  }

  // Confirm and soft-delete all grid items (is_active = false)
  onConfirmRemoveAllItems() {

    if (!this.gridItems || this.gridItems.length === 0) {
      this.publishRemoveAllToDocumentBridge();
      this.closeRemoveConfirmPopupAfterConfirm();
      return;
    }

    this.lastGridOperation = 'removeAll';

    // Soft-delete each row via dedicated backend endpoint that sets is_active = false
    // (bypasses IS_HARD_DELETE env which forces the standard delete endpoint to hard-delete)
    const updatePromises = this.gridItems.map(item => {
      const itemId = item[this.primaryColumn] || item.primary_id;
      return this.pageBuilderService.softDeleteFormResponse(itemId, this.formId).toPromise();
    });

    Promise.all(updatePromises)
      .then(() => {
        this.publishRemoveAllToDocumentBridge();
        this.closeRemoveConfirmPopupAfterConfirm();
        this.commitLocalGridItems([], false);
        this.alertService.success('Updated Successfully.');
      })
      .catch(error => {
        console.error('Error removing items:', error);
        this.closeRemoveConfirmPopupAfterConfirm();
        this.alertService.error('Error removing records. Please try again.');
      });
  }

  // Notify supporting-document-grid (and any other bridge subscriber) that all
  // records for this source grid have been removed so related documents can be
  // marked is_active = false for the same application + section.
  private publishRemoveAllToDocumentBridge(): void {
    const sourceGridKey = String(this._formattedName || '').trim();
    if (!sourceGridKey) {
      return;
    }

    const applicationId = this.formData?.applicationId
      ?? this.formData?.data?.application_id
      ?? this.sessionStorage.getItem('applicationID')
      ?? this.sessionStorage.getItem('applicationId')
      ?? null;

    const sectionName = this.formData?.sectionName
      ?? this.formData?.panelKey
      ?? this.formData?.section_name
      ?? this.formData?.panel_key
      ?? null;

    this.dynamicDocumentBridge.publish({
      sourceGridKey,
      operation: 'removeAll',
      rows: [],
      applicationId,
      sectionName
    });
  }

  // Close popup after user confirmed deletion (not canceled)
  private closeRemoveConfirmPopupAfterConfirm() {
    this.showRemoveConfirmPopup = false;
    this.confirmRemovalCanceled = false; // User confirmed, not canceled
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    if (!this.gridConfig && !this.isLoading && this.isVisible && this._formattedName) {
      setTimeout(() => {
        this.loadGridIfReady();
      }, 100);
    }

    if (this.formIO && !this.viewForm) {
      this.formIO.formio.on('change', (event) => {
        const focusedElement = document.activeElement;
        const hiddenAncestor = focusedElement?.closest('[aria-hidden="true"]');
        if (hiddenAncestor) {
          hiddenAncestor.setAttribute('aria-hidden', 'false');
          console.warn('Removed aria-hidden from:', hiddenAncestor);
        }
        event.data = {...event.data,
        pageId: this.formId,
        id: null        }
        this.formIoService.setPopupFormData(event);
        this.cdr.detectChanges();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.pendingGridLoadTimer) {
      clearTimeout(this.pendingGridLoadTimer);
      this.pendingGridLoadTimer = null;
    }
    this.subscriptions.unsubscribe();
    window.removeEventListener('supporting-document-uploaded', this.onDocumentUploaded);
  }

  onView(data) {
    this.isView = true;

    this.pageBuilderService
      .getMember(data.data[this.primaryColumn] || data.data.primary_id, this.formId)
      .pipe(
        filter((res: any) => res.status === 'success'),
        catchError(error => {
          throw new Error(error);
        })
      )
      .subscribe(res => {
        this.getForm().subscribe(() => {
          this.modalref = this.modalService.open(FormModalComponent, {
            centered: true,
            size: 'xl',
            backdrop: 'static',
            windowClass: 'custom-grid-form-modal'
          });
          let title = `View Record`;
          if(this.formData?.customAction && Array.isArray(this.formData?.customAction) && this.formData?.customAction.length > 0){
          const pageActionDetail = this.formData?.customAction.filter(action => action.pageId === this.gridId);
            if(pageActionDetail && pageActionDetail.length > 0 && Object.keys(pageActionDetail[0]).length > 0) {
             title = pageActionDetail[0].viewTitle || title;
            }
          }
          const isMatch = Array.isArray(this.formData?.notesPageId) ? this.formData?.notesPageId.includes(this.gridId) : this.gridId === this.formData?.notesPageId;
          this.modalref.componentInstance.title =  (isMatch && this.formData?.notesActionIcon?.viewTitle) ?  this.formData?.notesActionIcon.viewTitle : title;
          this.modalref.componentInstance.id = data.data.primary_id;
          this.modalref.componentInstance.submittedData = {
            data: {
              ...res.data,
              ...this.customData
            }
          };
          this.modalref.componentInstance.formJson = this.formJson;
          this.modalref.componentInstance.formId = this.formId;
          this.modalref.componentInstance.customData = this.customData;
          this.modalref.componentInstance.viewForm = true;
        });
      });
    // TODO: Handle view
  }

  // Implementation of the onSubmit method to handle form submissions
  async onSubmit($event) {
    const formioInstance = this.formIO?.formio;
    const formData = $event?.data || this.submittedData?.data;
    if (formioInstance) {
      const isValid = formioInstance.checkValidity(formData, true);
      if (!isValid) {
        this.alertService?.error('Please fill required fields');
        setTimeout(() => {
          const invalidElement = document.querySelector(
            'input.is-invalid, select.is-invalid, .selection.is-invalid, textarea.is-invalid'
          ) as HTMLElement;
          if (invalidElement) {
            invalidElement.focus();
          }
        }, 500);
        return;
      }
    }
    await this.getAdditionalFieldValues();

    const mergedData = { ...formData, ...this.customData };



    if (this.isDuplicateEntry(mergedData, null)) {
      this.alertService?.error('Duplicate entry detected. This record already exists.');
      return;
    }
    const allAttachments = Object.entries(formData)
      .filter(([, value]: [string, any]) => Array.isArray(value?.attachmentdetails) && value.attachmentdetails.length > 0)
      .reduce((acc: any[], [field, value]: [string, any]) => {
        const files = value.attachmentdetails.map((file: any) => {
          if (file?.path?.split('/')[5] !== field) {
            return null;
          }
          return {
            name: file.name,
            path: file.path.startsWith('http') ? file.path : `https://wy-base-doc.s3.amazonaws.com/${file.path}`,
            attachmenttype: file.attachmenttype || file.type || 'application/octet-stream',
            field,
            formid: value.formid,
            pageId: value.pageId,
            id: value.id,
            type: value.type
          };
        }).filter(Boolean);
        return acc.concat(files);
      }, []);
  let payload: any = {
    pageid: this.formId,
    response: formData
  };

  if (this.customData) {
    if (this.customData?.tbl_status && payload.response?.comments) {
      this.customData.tbl_status.comments = payload.response.comments;
    }
    payload.response = {
      ...payload.response,
      ...this.customData
    };
  }
  try {
    const data: any = await this.pageBuilderService.submitForm(payload).toPromise();
        const resultId = data?.data?.id;
        this.alertService.success(`Added Successfully.`);

        if (allAttachments.length && resultId) {
          const grouped = this.groupBy(allAttachments, 'field');
      for (const [field, attachments] of Object.entries(grouped)) {
            const attachmentPayload = {
              responseid: Number(resultId),
              type: attachments[0].type,
              formid: this.formId,
              pageId: this.formId,
              field,
              attachmentdetails: attachments.map(file => ({
                name: file.name,
                path: file.path,
                attachmenttype: file.attachmenttype,
                field
              }))
            };
            await this.addAttachment(attachmentPayload);
            // this.pageBuilderService.clearCacheFileByKey(`f-${this.formId}-${resultId}`);
          }
        }
          this.confirmRemovalCanceled = false; // Reset on grid data change
          this.lastGridOperation = 'add';
        this.addLocalGridItem({ ...payload.response, ...(data?.data || {}) }, resultId);
        this.submittedData = { data: {} };
        this.formIO?.formio?.resetValue();
        setTimeout(() => {
          this.evaluateAddCondition();
          this.calculateApplicationFees();
        }, 100);
  } catch (err) {
    this.alertService.error('Something went wrong! Please try again later');
    console.error(err);
  }
  }

private groupBy(array: any[], key: string): { [key: string]: any[] } {
    return array.reduce((acc, item) => {
      const group = item[key];
      if (!acc[group]) acc[group] = [];
      acc[group].push(item);
      return acc;
    }, {} as { [key: string]: any[] });
  }

  async addAttachment(info: { responseid: number, attachmentdetails: any[] }): Promise<void> {
    await this.pageBuilderService.createFormResponseAttachment(info).toPromise();
    // Handle attachment creation if needed
  }

  private getCurrApplicationType(): string {

      const currApplicationType = this.sessionStorage.getItem('currApplicationType');

      if (currApplicationType) {
        if (currApplicationType.startsWith('"') && currApplicationType.endsWith('"')) {
         return JSON.parse(currApplicationType);
        } else {
          return currApplicationType;
        }
      }

  }

  private getSessionTitle(): string {

      const titleData = this.sessionStorage.getItem('get-title');

      if (titleData) {
       if (titleData.startsWith('"') && titleData.endsWith('"')) {
          return JSON.parse(titleData);
        } else {
          return titleData;
        }
      }

  }

  private checkARLLicenseLimitCondition(): boolean {
    const currApplicationType = this.getCurrApplicationType();
    const sessionTitle = this.getSessionTitle();

    if (currApplicationType === 'ARL (Alternative Route to Licensure)' && sessionTitle === 'License-Details-Page') {
      return this.gridItems && this.gridItems.length >= 1;
    }

if (
  (currApplicationType === 'ARL + Substitute' ||
   currApplicationType === 'Substitute + ARL') &&
  sessionTitle === 'License-Details-Page'
) {
  return this.gridItems && this.gridItems.length >= 1;
}

    return false;
  }

  private isGridItemReadOnly(gridItem: any): boolean {
    return gridItem?.is_read_only === true ||
           gridItem?.is_read_only === 'true' ||
           gridItem?.is_read_only === 1 ||
           gridItem?.is_read_only === '1';
  }

  private isDuplicateEntry(formData: any, currentRecordId: number | null = null): boolean {
    const itemsToCheck = this.allGridItems.length > 0 ? this.allGridItems : this.gridItems;
    if (!itemsToCheck || itemsToCheck.length === 0) {
      return false;
    }


    if (itemsToCheck.length > 0) {
      console.log('First grid item data types:', Object.keys(itemsToCheck[0]).map(key => ({
        field: key,
        value: itemsToCheck[0][key],
        type: typeof itemsToCheck[0][key],
        isDate: itemsToCheck[0][key] instanceof Date
      })));
    }

   const excludeFields = ['id', 'primary_id', 'primary_object', 'application_id', 'person_id',
                           'pageId', 'formid', 'type', 'comments', 'textField', 'value', 'endorsement',
                           'license_kind_endorsement_id', 'created_by', 'created_date',
                           'updated_by', 'updated_date', 'is_active', 'is_read_only', 'is_new'];

    const formDataFields = Object.keys(formData).filter(key =>
      !excludeFields.includes(key) &&
      !key.startsWith('tbl_') &&
      !key.endsWith('_id') &&
      !key.includes('created') &&
      !key.includes('updated') &&
      typeof formData[key] !== 'object' &&
      formData[key] !== null &&
      formData[key] !== undefined &&
      formData[key] !== ''
    );


    if (formDataFields.length === 0) {
      return false;
    }

    const isDuplicate = itemsToCheck.some((gridItem, index) => {
      // Skip comparison with the current record being edited
      if (currentRecordId !== null) {
        const gridItemId = gridItem.primary_id || gridItem.id;
        if (gridItemId === currentRecordId) {
          return false; // Skip this item as it's the one being edited
        }
      }

      let matchCount = 0;
      let fieldsChecked = 0;

      for (const field of formDataFields) {
        const formValue = formData[field];
        let gridValue = undefined;
        let fieldExists = false;

        if (gridItem.hasOwnProperty(field)) {
          gridValue = gridItem[field];
          fieldExists = true;
        } else {
          for (const key in gridItem) {
            if (typeof gridItem[key] === 'object' && gridItem[key] !== null && !Array.isArray(gridItem[key])) {
              if (gridItem[key].hasOwnProperty(field)) {
                gridValue = gridItem[key][field];
                fieldExists = true;
                break;
              }
            }
          }
        }

        if (!fieldExists) {
          continue; // Skip this field instead of returning false
        }

        fieldsChecked++;


        const normalizedFormValue = this.normalizeValue(formValue);
        const normalizedGridValue = this.normalizeValue(gridValue);
        const isMatch = normalizedFormValue === normalizedGridValue && normalizedFormValue !== '';


        if (isMatch) {
          matchCount++;
        } else {
         console.log(`  Field '${field}' doesn't match - NOT a duplicate`);
          return false;
        }
      }

      // Consider it a duplicate if we checked at least one field and all checked fields matched
      const result = fieldsChecked > 0 && matchCount === fieldsChecked;
      console.log(`Grid item [${index}]: ${matchCount}/${fieldsChecked} fields matched (${formDataFields.length} total form fields), isDuplicate=${result}`);
      return result;
    });

    console.log('=== FINAL RESULT:', isDuplicate, '===\n');
    return isDuplicate;
  }


  private normalizeValue(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

   if (value instanceof Date || this.isDateString(value)) {
      return this.normalizeDateValue(value);
    }

    if (typeof value === 'number' || !isNaN(parseFloat(value))) {
      return parseFloat(value).toString();
    }

    if (typeof value === 'object') {
      return JSON.stringify(value);
    }

    return String(value).trim().toLowerCase();
  }


  private isDateString(value: any): boolean {
    if (typeof value !== 'string') {
      return false;
    }

    const datePattern = /^\d{4}-\d{2}-\d{2}/;
    return datePattern.test(value);
  }

  private normalizeDateValue(value: any): string {
    try {
      let dateObj: Date;

      if (value instanceof Date) {
        dateObj = value;
      } else {
        dateObj = new Date(value);
      }

      if (isNaN(dateObj.getTime())) {
        return String(value).trim().toLowerCase();
      }

      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    } catch (e) {
      return String(value).trim().toLowerCase();
    }
  }

  private fetchFeeLookup(): void {
    this.httpService.get('/domain/lookup?requestType=FEE_CATEGORY').subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        this.feeLookupData = data;
      },
      error: (err) => {
        console.error('Failed to fetch FEE_CATEGORY lookup:', err);
      }
    });
  }

  private getFeeByKey(key: string): number {
    const row = this.feeLookupData.find(item => String(item.key) === key);
    if (!row) {
      console.warn(`Fee lookup: no entry found for key="${key}"`);
      return 0;
    }
    const opt = typeof row.optionaldata === 'string' ? JSON.parse(row.optionaldata) : row.optionaldata;
    return Number(opt?.fee) || 0;
  }

  private calculateApplicationFees(): void {
    // Fee session values (applicationTotalFee, LiceanceEndrosementFee, additionalEndorsementUnitFee,
    // additionalEndorsementCount, extensionFee) are now set exclusively by the fee preview popup
    // (Next button). This method only sets the base applicationFee for the popup to read.
    if (!this.feeLookupData || this.feeLookupData.length === 0) return;

    const sessionTitle = this.getSessionTitle();
    if (sessionTitle === 'License-Details-Page') {
      const rawLicPath = this.sessionStorage.getItem('license-path') || '';
      const licPath = rawLicPath.replace(/^["']|["']$/g, '');
      const feeKeyMap: Record<string, string> = { '1': '2', '2': '7', '3': '1', '4': '8' };
      const baseFeeKey = feeKeyMap[licPath] || '1';
      const baseFee = this.getFeeByKey(baseFeeKey);
      if (baseFee > 0) {
        this.sessionStorage.setItem('applicationFee', JSON.stringify(baseFee));
      }
    }
  }


  onMarkAsAddressed(data, confirmAddressedModel) {
    this.primaryId = data.data[this.primaryColumn] || data.data.primary_id;
    this.noteIdValue = data?.data?.[this.noteIdColumn] || data?.data?.note_id;
    this.modalref = this.modalService.open(confirmAddressedModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details def-view-details-modal'
    });
    this.modalref.componentInstance.title = 'Delete Record';
  }

  onMarkAsValid(data, confirmValidationModel) {
    this.actionText = null;
    this.primaryId = data.data[this.primaryColumn] || data.data.primary_id;
    this.noteIdValue = data?.data?.[this.noteIdColumn] || data?.data?.note_id;
    this.modalref = this.modalService.open(confirmValidationModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details def-confirmval-details-modal'
    });
    this.modalref.componentInstance.title = 'Delete Record';
  }


  onMarkAsDeficient(data, confirmDeficiencyModel) {
    this.actionText = null;
    this.primaryId = data.data[this.primaryColumn] || data.data.primary_id;
    this.noteIdValue = data?.data?.[this.noteIdColumn] || data?.data?.note_id;
    this.actionText = data?.data?.note_text ? data?.data?.note_text : (data?.data?.deficiency_notes ? data?.data?.deficiency_notes : ''); ;
    this.modalref = this.modalService.open(confirmDeficiencyModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details def-confirmdef-details-modal'
    });
    this.modalref.componentInstance.title = 'Delete Record';
  }

  onViewDeficientComments(data, viewDeficiencyModel) {
    this.primaryId = data.data[this.primaryColumn] || data.data.primary_id;
    this.noteIdValue = data?.data?.[this.noteIdColumn] || data?.data?.note_id;
    let rawHtml = data?.data?.note_text ? data?.data?.note_text : (data?.data?.deficiency_notes ? data?.data?.deficiency_notes : '');
    this.viewNotesText =  this.sanitized.bypassSecurityTrustHtml(rawHtml || '');
    this.modalref = this.modalService.open(viewDeficiencyModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  //  onMarkAsAddressedItem() {
  //    const body = {
  //     id: this.primaryId,
  //     reviewStatus: 'Addressed',
  //     reviewNotes: this.actionText
  //   };
  //   this.pageBuilderService
  //     .post(`/application-flow/notes/save-action`, body)
  //     .pipe(filter((res: any) => res.status === 'success'))
  //     .subscribe(_ => {
  //       this.closePopup();
  //       this.getGridConfig();
  //       setTimeout(() => {
  //         this.evaluateAddCondition();
  //         this.calculateApplicationFees();
  //       }, 100);
  //       this.alertService.success("Saved Successfully.");
  //     });
  // }

  //  onMarkAsValidItem() {

  //   const body = {
  //     id: this.primaryId,
  //     reviewStatus: 'Validated',
  //     reviewNotes: this.actionText
  //   };
  //   this.pageBuilderService
  //     .post(`/application-flow/notes/save-action`, body)
  //     .pipe(filter((res: any) => res.status === 'success'))
  //     .subscribe(_ => {
  //       this.closePopup();
  //       this.getGridConfig();
  //       setTimeout(() => {
  //         this.evaluateAddCondition();
  //         this.calculateApplicationFees();
  //       }, 100);
  //       this.alertService.success("Saved Successfully.");
  //     });
  // }

  //  onMarkAsDeficientItem() {
  //    const body = {
  //     id: this.primaryId,
  //     reviewStatus: 'Deficient',
  //     reviewNotes: this.actionText
  //   };
  //   this.pageBuilderService
  //     .post(`/application-flow/notes/save-action`, body)
  //     .pipe(filter((res: any) => res.status === 'success'))
  //     .subscribe(_ => {
  //       this.closePopup();
  //       this.getGridConfig();
  //       setTimeout(() => {
  //         this.evaluateAddCondition();
  //         this.calculateApplicationFees();
  //       }, 100);
  //       this.alertService.success("Saved Successfully.");
  //     });
  // }

  // showCustomAction() {
  //   const isMatch = Array.isArray(this.formData?.notesPageId) ? this.formData?.notesPageId.includes(this.gridId) : this.gridId === this.formData?.notesPageId;
  //   if(isMatch && this.formData?.notesActionIcon && Object.keys(this.formData?.notesActionIcon).length > 0){
  //      this.gridCustomActions.isShowMarkAsAddressed = this.formData?.notesActionIcon?.isShowMarkAsAddressed;
  //      this.gridCustomActions.isShowMarkAsValid = this.formData?.notesActionIcon?.isShowMarkAsValid;
  //      this.gridCustomActions.isShowMarkAsDeficient = this.formData?.notesActionIcon?.isShowMarkAsDeficient;
  //      this.gridCustomActions.isShowView = this.formData?.notesActionIcon?.isShowView;
  //      this.gridCustomActions.isShowEdit = this.formData?.notesActionIcon?.isShowEdit;
  //      this.gridCustomActions.isShowDelete = this.formData?.notesActionIcon?.isShowDelete;
  //      this.gridCustomActions.isShowViewDeficiencyNotes = this.formData?.notesActionIcon?.isShowViewDeficiencyNotes;
  //    }


  /**
   * Check if action buttons should be shown for a specific grid item
   * based on is_read_only flag from the API response
   */
  shouldShowActionsForItem(gridItem: any): boolean {
    // If is_read_only is true (boolean or string), hide action buttons
    const isReadOnly = gridItem?.is_read_only === true ||
                       gridItem?.is_read_only === 'true' ||
                       gridItem?.is_read_only === 1 ||
                       gridItem?.is_read_only === '1';

    if (isReadOnly && this.loginUserRoleId === 405) {
      return false;
    }

    // If is_read_only is false or doesn't exist, show action buttons
    return true;
  }

  /**
   * Check if a specific action (edit, view, delete) should be shown for a grid item
   */
  shouldShowActionType(gridItem: any, actionType: 'edit' | 'view' | 'delete'): boolean {
    if (this.readOnly) {
      return actionType === 'view';
    }
    // First check the general action visibility
    if (!this.shouldShowActionsForItem(gridItem)) {
      return false;
    }

    if (['edit', 'view', 'delete'].includes(actionType)) {
      return true;
    } else {
      return false;
    }
    // Then check the specific action type flags
    // switch(actionType) {
    //   case 'edit':
    //     return this.gridCustomActions.isShowEdit === true;
    //   case 'view':
    //     return this.gridCustomActions.isShowView === true;
    //   case 'delete':
    //     return this.gridCustomActions.isShowDelete === true;
    //   default:
    //     return false;
    // }
  }

  private emitGridValueEvent(gridItems, emitToFormio = true): void {
    const key = this._formattedName;

    this.value = {
      [key]: gridItems,
      [`${key}_isVisible`]: this.isVisible,
      confirmRemovalCanceled: this.confirmRemovalCanceled
    };



    // Emit for Form.io data binding
    if (emitToFormio) {
      this.valueChange.emit(this.value);

      // Emit custom Form.io event
      this.formioEvent.emit({
        eventName: 'customEvent',
        data: {
          value: this.value,
          type: key,
          key: key
        }
      });
    }

    if (this.coerceBoolean(this.isDynamicDocumentRequired)) {
      this.dynamicDocumentBridge.publish({
        sourceGridKey: key,
        operation: this.lastGridOperation,
        rows: gridItems
      });

      this.formioEvent.emit({
        eventName: 'dynamicDocumentRequired',
        data: {
          value: this.value,
          type: key,
          key,
          sourceGridKey: key,
          operation: this.lastGridOperation,
          allRows: gridItems
        }
      });
    }

    // Note: confirmRemovalCanceled is NOT auto-reset here.
    // It persists until a grid data change (add/edit/delete) clears it,
    // keeping the radio disabled until the user modifies the grid.
  }

  coerceBoolean(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'number') {
      return value === 1;
    }
    return ['true', '1', 'yes', 'y'].includes(String(value ?? '').trim().toLowerCase());
  }

  isResolveMode(): boolean {
    return this.coerceBoolean(this.isResolveProvisions) || this.coerceBoolean(this.isResolveRequirement);
  }

  getResolveDisplayValue(gridItem: any): string {
    if (this.coerceBoolean(this.isResolveRequirement)) {
      return gridItem?.requirement_value || '';
    }
    return gridItem?.provision_value || '';
  }


  calculateActionWidthForRow(data) {
  let width = 120;

  if (this.gridCustomActions.isShowMarkAsAddressed &&
      data?.notes_type === 'Deficiency' &&
      (!data?.review_status || data?.review_status === 'Deficient' || data?.review_status === 'Pending Review')) {
    width += 35;
  }

  if (this.gridCustomActions.isShowMarkAsValid &&
      data?.notes_type === 'Deficiency' &&
      data?.review_status === 'Addressed') {
    width += 35;
  }

  if (this.gridCustomActions.isShowMarkAsDeficient &&
      data?.notes_type === 'Deficiency' &&
      data?.review_status === 'Addressed') {
    width += 35;
  }

  return Math.max(width + 20, 120);
}


actionColumnWidth: number = 280;

setActionColumnWidth(e) {
  if (this.isResolveMode()) {
    this.actionColumnWidth = 100;
    return;
  }
  const rows = e.component.getDataSource().items();

  let maxWidth = 280;

  rows.forEach(row => {
    const w = this.calculateActionWidthForRow(row);
    if (w > maxWidth) {
      maxWidth = w;
    }
  });
  this.actionColumnWidth = maxWidth;
}

/**
 * Highlight row if is_highlighted or is_highlighted_update is true in the row data
 * Only applies when role_id is not 405 (same condition as is_new star)
 */
onRowPrepared(e: any): void {
  if (e.rowType === 'data' && this.loginUserRoleId !== 405) {
    const isHighlighted = e.data?.is_highlighted === true ||
                          e.data?.is_highlighted === 'true' ||
                          e.data?.is_highlighted === 1 ||
                          e.data?.is_highlighted === '1';

    const isHighlightedUpdate = e.data?.is_highlighted_update === true ||
                                 e.data?.is_highlighted_update === 'true' ||
                                 e.data?.is_highlighted_update === 1 ||
                                 e.data?.is_highlighted_update === '1';

    if (isHighlighted) {
      e.rowElement.classList.add('highlighted-row');

      e.rowElement.addEventListener('mouseenter', () => {
        Array.from<HTMLElement>(e.rowElement.querySelectorAll('td')).forEach((cell) => {
          cell.style.setProperty('background-color', '#F4F8FF', 'important');
        });
      });

      e.rowElement.addEventListener('mouseleave', () => {
        Array.from<HTMLElement>(e.rowElement.querySelectorAll('td')).forEach((cell) => {
          cell.style.removeProperty('background-color');
        });
      });
    } else if (isHighlightedUpdate) {
      e.rowElement.classList.add('highlighted-row-update');

      e.rowElement.addEventListener('mouseenter', () => {
        Array.from<HTMLElement>(e.rowElement.querySelectorAll('td')).forEach((cell) => {
          cell.style.setProperty('background-color', '#FFFBEF', 'important');
        });
      });

      e.rowElement.addEventListener('mouseleave', () => {
        Array.from<HTMLElement>(e.rowElement.querySelectorAll('td')).forEach((cell) => {
          cell.style.removeProperty('background-color');
        });
      });
    }
  }
}

/**
 * Check if star icon should be shown for new items
 * Shows on all pages when is_new is true and role_id is not 405
 */
shouldShowNewItemStar(gridItem: any): boolean {
  if (this.loginUserRoleId !== 405) {
    const isNew = gridItem?.is_new === true ||
                  gridItem?.is_new === 'true' ||
                  gridItem?.is_new === 1 ||
                  gridItem?.is_new === '1';

    return isNew;
  }

  return false;
}

  get wordCount(): number {
  return this.actionText
    ? this.actionText.trim().split(/\s+/).filter(w => w).length
    : 0;
  }

   onViewAddressedNotes(data, viewDeficiencyNotes) {
    this.primaryId = data.data[this.primaryColumn] || data.data.primary_id;
    this.noteIdValue = data?.data?.[this.noteIdColumn] || data?.data?.note_id;
    this.actionText = data?.data?.addressed_notes || '';
    this.modalref = this.modalService.open(viewDeficiencyNotes, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details def-add-details-modal'
    });
    this.modalref.componentInstance.title = 'Delete Record';
  }

  checkReadOnlyMode() {
    if (this.readOnlyCondition) {
      try {
        const addButtonScript = this.readOnlyCondition.replace(/sessionStorage/g, 'sessionStorageService');
        const prefix = 'var readOnlyCondition = false;';
        const suffix = ';return { readOnlyCondition: readOnlyCondition };';
        const fnDef = new Function('data', 'sessionStorageService', `${prefix}${addButtonScript}${suffix}`);
        const result = fnDef(this.formData || {}, this.sessionStorage);
        this.readOnly = result.readOnlyCondition;
      } catch (e) {
        console.error('Error evaluating read only condition:', e);
        this.readOnly = false;
      }
    } else {
      this.readOnly = false;
    }
  }

  customFunction(rowData: any, functionBody: string){
     const fnDef = new Function('data', 'sessionStorageService', 'rowData', functionBody);
     const result = fnDef(this.formData || {}, this.sessionStorage, rowData);
     return result;
  }

  onShowAction(data, action) {
  let actionValues: any = {};
  const isMatch = Array.isArray(this.formData?.notesPageId) ? this.formData?.notesPageId.includes(this.gridId) : this.gridId === this.formData?.notesPageId;
  if (isMatch && this.formData?.notesActionIcon && Object.keys(this.formData?.notesActionIcon).length > 0) {
    actionValues = this.formData?.notesActionIcon;
  }
  else if(this.formData?.customAction && Array.isArray(this.formData?.customAction) && this.formData?.customAction.length > 0) {
    const pageActionDetail = this.formData?.customAction.filter(action => action.pageId === this.gridId);
    if (pageActionDetail && pageActionDetail.length > 0 && Object.keys(pageActionDetail[0]).length > 0) {
      actionValues = pageActionDetail[0];
    }
  }
  const evaluateActionCondition = (conditionFunctionBody: string) => {
    return this.customFunction(data ,conditionFunctionBody);
  };

  const actionMap: { [key: string]: string } = {
    'edit': 'isShowEdit',
    'view': 'isShowView',
    'delete': 'isShowDelete',
    'markasaddressed': 'isShowMarkAsAddressed',
    'markasvalid': 'isShowMarkAsValid',
    'markasdeficient': 'isShowMarkAsDeficient',
    'viewdeficiencynotes': 'isShowViewDeficiencyNotes',
    'viewaddressednotes': 'isShowViewAddressedNotes'
  };

  const conditionMap: { [key: string]: string } = {
    'edit': 'showEditCondition',
    'view': 'showViewCondition',
    'delete': 'showDeleteCondition',
    'markasaddressed': 'showMarkAsAddressedCondition',
    'markasvalid': 'showMarkAsValidCondition',
    'markasdeficient': 'showMarkAsDeficientCondition',
    'viewdeficiencynotes': 'showViewDeficiencyNotesCondition',
    'viewaddressednotes': 'showViewAddressedNotesCondition'
  };
  if(action == 'markasaddressed'){
    let test = '';
  }
  if(action == 'markasvalid'){
    let test = '';
  }
  if(action == 'markasdeficient'){
    let test = '';
  }
  if(action == 'viewdeficiencynotes'){
    let test = '';
  }
  if (actionMap[action]) {
    const actionProperty = actionMap[action];
    const conditionProperty = conditionMap[action];
    if(conditionProperty && actionValues[conditionProperty] && actionValues[actionProperty]) {
      const conditionFunctionBody = actionValues[conditionProperty];
      this.gridCustomActions[actionProperty] = evaluateActionCondition(`return ${conditionFunctionBody}`) ?? actionValues[actionProperty];
    }
    else if([true, false].includes(actionValues[actionProperty])) {
      this.gridCustomActions[actionProperty] = actionValues[actionProperty];
    }
    return this.gridCustomActions[actionProperty];
  }
}

 updateItemStatus(status) {
  const body = {
    id: this.primaryId,
    reviewStatus: status,
    reviewNotes: this.actionText,
    noteId: this.noteIdValue,
    ...(this.deficiencyDetails || {})
  };
  this.pageBuilderService
    .post(`/application-flow/notes/save-action`, body)
    .pipe(filter((res: any) => res.status === 'success'))
    .subscribe(_ => {
      this.closePopup();
      this.lastGridOperation = 'edit';
      this.updateLocalGridItem({
        review_status: status,
        deficiency_status: status,
        addressed_notes: status === 'Addressed' ? this.actionText : undefined,
        deficiency_notes: status === 'Deficient' ? this.actionText : undefined,
        note_text: this.actionText
      }, this.primaryId);
      setTimeout(() => {
        this.evaluateAddCondition();
        this.calculateApplicationFees();
      }, 100);
      this.alertService.success("Saved Successfully.");
    });
  }

  onMarkAsAddressedItem() {
    this.updateItemStatus('Addressed');
  }

  onMarkAsValidItem() {
    this.updateItemStatus('Validated');
  }

  onMarkAsDeficientItem() {
    this.updateItemStatus('Deficient');
  }

  saveDeficiencyDetails() {
    if(this.formData?.customAction && Array.isArray(this.formData?.customAction) && this.formData?.customAction.length > 0){
     const pageActionDetail = this.formData?.customAction.filter(action => action.pageId === this.gridId);
      if(pageActionDetail && pageActionDetail.length > 0 && Object.keys(pageActionDetail[0]).length > 0) {
       this.deficiencyDetails.sectionCode = pageActionDetail[0].sectionCode;
       this.deficiencyDetails.tabName = pageActionDetail[0].tabName;
       this.deficiencyDetails.deficiencyType = pageActionDetail[0].deficiencyType;
       this.deficiencyDetails.isNotesPage = pageActionDetail[0].isNotesPage;
       this.deficiencyDetails.applicationId = this.formData?.applicationId;
       this.deficiencyDetails.userId = this.formData?.loginUserId;
       this.deficiencyDetails.deficiencyHighlightCondition = pageActionDetail[0].deficiencyHighlightCondition;
       this.noteIdColumn = this.formData?.noteIdColumn;
       }
    }
  }

  // onRowPrepared(e: any): void {
  //   if (!e || e.rowType !== 'data') {
  //     return;
  //   }
  //   const shouldHighlight = this.shouldHighlightDeficientRow(e.data);
  //   const rowElement = (e.rowElement?.classList ? e.rowElement : e.rowElement?.[0]) as HTMLElement | undefined;
  //   if (!rowElement?.classList) {
  //     return;
  //   }

  //   rowElement.classList.toggle('deficient-row', shouldHighlight);
  //   const cells = Array.from(rowElement.querySelectorAll('td'));
  //   cells.forEach((cell: Element, index: number) => {
  //     const element = cell as HTMLElement;
  //     element.classList.toggle('deficient-cell', shouldHighlight);
  //     if (shouldHighlight) {
  //       element.style.setProperty('background', 'var(--deficient-row-bg-color)', 'important');
  //       element.style.setProperty('background-color', 'var(--deficient-row-bg-color)', 'important');
  //       element.style.setProperty('background-image', 'none', 'important');
  //       element.style.setProperty('border-top-color', 'var(--deficient-row-border-color)', 'important');
  //       element.style.setProperty('border-bottom-color', 'var(--deficient-row-border-color)', 'important');
  //       if (index === 0) {
  //         element.style.setProperty('box-shadow', 'inset 4px 0 0 var(--deficient-row-accent-color)', 'important');
  //       }
  //     } else {
  //       element.style.removeProperty('background');
  //       element.style.removeProperty('background-color');
  //       element.style.removeProperty('background-image');
  //       element.style.removeProperty('border-top-color');
  //       element.style.removeProperty('border-bottom-color');
  //       if (index === 0) {
  //         element.style.removeProperty('box-shadow');
  //       }
  //     }
  //   });
  // }

  private shouldHighlightDeficientRow(row: any): boolean {
    if(this.deficiencyDetails.deficiencyHighlightCondition) {
      const evaluateActionCondition = (conditionFunctionBody: string) => {
            return this.customFunction(row ,conditionFunctionBody);
       };
      return evaluateActionCondition(`return ${this.deficiencyDetails.deficiencyHighlightCondition}`) ?? false;
    }
  }
 private normalizeStatus(value: any): string {
    return String(value || '').trim().toLowerCase();
  }
  statusClass(status: string): string {
    const statusLower = this.normalizeStatus(status);
    switch (statusLower) {
      case 'deficient':
        return 'status-deficient';
      case 'validated':
        return 'status-validated';
      case 'addressed':
        return 'status-pending';
      case 'pending review':
        return 'status-pending';
      case 'pending':
        return 'status-pending';
      case 'received':
        return 'status-validated';
      case 'active':
        return this.isResolveMode() ? 'status-active' : 'status-validated';
      case 'requested':
        return 'status-requested';
      case 'resolved':
        return 'status-resolved';
      case 'past due':
        return 'status-pastdue';
      case 'inactive':
        return 'status-inactive';
      default:
        return 'status-default';
    }
  }
containsHtml(value: any): boolean {
  if (!value || typeof value !== 'string') {
    return false;
  }
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

shouldShowTranscriptAction(gridItem: any): boolean {
    if (!this.coerceBoolean(this.isTranscriptNeeded)) {
      return false;
    }
    if (this.loginUserRoleId === 405) {
      return false;
    }
    if (gridItem?.cd_credential_type === 1 || gridItem?.cd_credential_type === '1') {
      return false;
    }
    const transcriptStatus = this.normalizeStatus(gridItem?.transcript_status);
    if (transcriptStatus !== 'pending') {
      return false;
    }
    return true;
  }

  onMarkTranscriptReceived(data, confirmTranscriptModel) {
    const rowData = data.data;
    this.transcriptRowData = rowData;
    this.primaryId = rowData[this.primaryColumn] || rowData.primary_id;

    const institutionName = rowData.institution_name || '';
    const major = rowData.major_minor_value || '';
    const cdDegreeEarned = rowData.cd_degree_earned;
    const degreeEarnedValue = rowData.degree_earned_value;

    if (cdDegreeEarned === 0 || cdDegreeEarned === '0' || (degreeEarnedValue && degreeEarnedValue.toLowerCase() === 'yes')) {
      const completionDate = rowData.completion_date ? new Date(rowData.completion_date).toLocaleDateString('en-US') : '';
      const message = `By clicking Confirm, you are indicating that the transcript for <b>${institutionName}, ${major},</b> with a Degree Completion Date of <b>${completionDate}</b>, has been received and uploaded.`;
      this.transcriptMessage = this.sanitized.bypassSecurityTrustHtml(message);
    } else {
      const creditsEarned = rowData.credit_earned || '';
      const message = `By clicking Confirm, you are indicating that the transcript for <b>${institutionName}, ${major},</b> with <b>${creditsEarned}</b> credits earned, has been received and uploaded.`;
      this.transcriptMessage = this.sanitized.bypassSecurityTrustHtml(message);
    }

    this.modalref = this.modalService.open(confirmTranscriptModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onConfirmTranscript() {
    this.autoUpdateTranscriptStatus(this.primaryId, true);
  }

  private checkAutoTranscript(formData: any): void {
    if (!this.coerceBoolean(this.isTranscriptNeeded)) return;
    if (!this.allGridItems || this.allGridItems.length === 0) return;

    // Find grid items where cd_credential_type === 1 and transcript not yet received
    const eligibleItems = this.allGridItems.filter(item =>
      (item.cd_credential_type === 1 || item.cd_credential_type === '1') &&
      this.normalizeStatus(item.transcript_status) !== 'received'
    );
    if (eligibleItems.length === 0) return;

    // Count REAL uploaded documents with category "10" (skip placeholders)
    let docCount = 0;
    for (const key of Object.keys(formData || {})) {
      const value = formData[key];
      if (!Array.isArray(value) || value.length === 0) continue;
      if (value[0]?.cd_document_category === undefined) continue;

      for (const doc of value) {
        if (doc.isPlaceholder === true || doc._placeholderKey) continue;
        if (doc.is_active === false) continue;
        if (this.normalizeStatus(doc.status) === 'archived') continue;
        // Must have a file uploaded (file_name or file_hash present)
        if (!doc.file_name && !doc.file_hash) continue;
        if (String(doc.cd_document_category || '').trim() === '10') {
          docCount++;
        }
      }
    }

    // Trigger when uploaded doc count meets eligible grid items count
    if (docCount >= eligibleItems.length) {
      for (const gridItem of eligibleItems) {
        const itemId = gridItem[this.primaryColumn] || gridItem.primary_id;
        if (!this.pendingTranscriptUpdates.has(itemId)) {
          this.pendingTranscriptUpdates.add(itemId);
          this.autoUpdateTranscriptStatus(itemId, false);
        }
      }
    }
  }

  private triggerAutoTranscriptUpdate(): void {
    if (!this.coerceBoolean(this.isTranscriptNeeded)) return;

    const doUpdate = () => {
      if (!this.allGridItems || this.allGridItems.length === 0) return;
      const eligibleItems = this.allGridItems.filter(item =>
        (item.cd_credential_type === 1 || item.cd_credential_type === '1') &&
        this.normalizeStatus(item.transcript_status) !== 'received'
      );
      for (const gridItem of eligibleItems) {
        const itemId = gridItem[this.primaryColumn] || gridItem.primary_id;
        if (!this.pendingTranscriptUpdates.has(itemId)) {
          this.pendingTranscriptUpdates.add(itemId);
          this.autoUpdateTranscriptStatus(itemId, false);
        }
      }
    };

    // Refresh grid first to get latest data, then update
    if (this._formattedName && this.gridId) {
      const queryCondition = this.getQueryCondition();
      this.pageBuilderService
        .getGridResult(this.gridId, queryCondition, this._formattedName, true)
        .subscribe((response: any) => {
          if (response?.data) {
            const results = response.data.response?.result || [];
            this.allGridItems = results.map(r => {
              return r.row.reduce((obj, d) => {
                if (d.name.includes('.')) {
                  const [table, column] = d.name.split('.');
                  if (table === this.primaryColumn) {
                    obj[column] = d.value;
                  } else {
                    obj[table] = obj[table] || {};
                    obj[table][column] = d.value;
                  }
                } else {
                  obj[d.name] = d.value;
                }
                return obj;
              }, {});
            });
          }
          doUpdate();
        });
    } else {
      doUpdate();
    }
  }

  private autoUpdateTranscriptStatus(primaryId: any, showAlert: boolean): void {
    this.pageBuilderService
      .getMember(primaryId, this.formId)
      .pipe(
        filter((res: any) => res.status === 'success'),
        catchError(error => {
          this.pendingTranscriptUpdates.delete(primaryId);
          console.error('Error auto-updating transcript status:', error);
          throw error;
        })
      )
      .subscribe(res => {
        const payload = {
          pageid: this.formId,
          response: {
            ...res.data,
            ...this.customData,
            transcript_status: 'Received',
            transcript_received_date: new Date().toISOString()
          }
        };

        this.pageBuilderService.editForm(payload, primaryId)
          .pipe(filter((result: any) => result))
          .subscribe(_ => {
            this.pendingTranscriptUpdates.delete(primaryId);
            if (showAlert) {
              this.closePopup();
            }
            this.lastGridOperation = 'edit';
            this.updateLocalGridItem({
              transcript_status: 'Received',
              transcript_received_date: payload.response.transcript_received_date
            }, primaryId);
            setTimeout(() => { this.evaluateAddCondition(); }, 100);
            this.alertService.success('Status updated successfully.');
          });
      });
  }

  // ==================== Resolve Provisions ====================

  shouldShowRequestResolution(gridItem: any): boolean {
    if (!this.isResolveMode()) {
      return false;
    }
    if (this.loginUserRoleId !== 405) {
      return false;
    }
    const status = this.normalizeStatus(gridItem?.cd_status);
    if (status === 'resolved') {
      return false;
    }
    const resolutionRequested = gridItem?.resolution_requested || gridItem?.Resolution_Requested;
    if (resolutionRequested === true || resolutionRequested === 'true' || resolutionRequested === 'True' || resolutionRequested === true) {
      return false;
    }
    return true;
  }

  shouldShowCancelResolution(gridItem: any): boolean {
    if (!this.isResolveMode()) {
      return false;
    }
    if (this.loginUserRoleId !== 405) {
      return false;
    }
    const resolutionRequested = gridItem?.resolution_requested || gridItem?.Resolution_Requested;
    if (resolutionRequested === true || resolutionRequested === 'true' || resolutionRequested === 'True') {
      return true;
    }
    return false;
  }

  shouldShowViewResolutionNotes(gridItem: any): boolean {
    if (!this.isResolveMode()) {
      return false;
    }
    const notes = gridItem?.resolution_notes;
    return !!notes && String(notes).trim().length > 0;
  }

  onViewResolutionNotes(data: any, viewResolutionNotesModel: any) {
    const rowData = data.data;
    this.viewResolutionNotesText = rowData.resolution_notes || '';
    this.resolutionProvisionValue = this.getResolveDisplayValue(rowData);
    this.modalref = this.modalService.open(viewResolutionNotesModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  hasAnyResolutionAction(): boolean {
    if (!this.isResolveMode()) {
      return false;
    }
    if (!this.gridItems || this.gridItems.length === 0) {
      return false;
    }
    return this.gridItems.some(item =>
      this.shouldShowRequestResolution(item) ||
      this.shouldShowCancelResolution(item) ||
      this.shouldShowViewResolutionNotes(item)
    );
  }

  onRequestResolution(data: any, requestResolutionModel: any) {
    const rowData = data.data;
    this.resolutionRowData = rowData;
    this.primaryId = rowData[this.primaryColumn] || rowData.primary_id;
    this.resolutionProvisionValue = this.getResolveDisplayValue(rowData);
    this.resolutionNotes = '';
    this.resolutionNotesInvalid = true;

    this.modalref = this.modalService.open(requestResolutionModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onResolutionNotesChange(value: string) {
    this.resolutionNotes = value;
    this.resolutionNotesInvalid = !value || value.trim().length === 0;
  }

  onConfirmRequestResolution() {
    if (!this.resolutionNotes || this.resolutionNotes.trim().length === 0) {
      return;
    }
    console.log('[Resolution] primaryId:', this.primaryId);
    console.log('[Resolution] formId:', this.formId);
    console.log('[Resolution] resolutionRowData:', this.resolutionRowData);

    const payload = {
      pageid: this.formId,
      response: {
        ...this.resolutionRowData,
        ...this.customData,
        resolution_requested: true,
        resolution_notes: this.resolutionNotes.trim()
      }
    };
    console.log('[Resolution] editForm payload:', payload);

    this.pageBuilderService.editForm(payload, this.primaryId)
      .pipe(filter((result: any) => result))
      .subscribe({
        next: (_) => {
          this.closePopup();
          this.lastGridOperation = 'edit';
          this.updateLocalGridItem({
            resolution_requested: true,
            resolution_notes: this.resolutionNotes.trim()
          }, this.primaryId);
          this.alertService.success('Resolution requested successfully.');
        },
        error: (err) => {
          console.error('[Resolution] editForm error:', err);
          this.alertService.error('Failed to request resolution. Please try again.');
        }
      });
  }

  onCancelResolution(data: any, cancelResolutionModel: any) {
    const rowData = data.data;
    this.resolutionRowData = rowData;
    this.primaryId = rowData[this.primaryColumn] || rowData.primary_id;
    this.resolutionProvisionValue = this.getResolveDisplayValue(rowData);

    this.modalref = this.modalService.open(cancelResolutionModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onConfirmCancelResolution() {
    const payload = {
      pageid: this.formId,
      response: {
        ...this.resolutionRowData,
        ...this.customData,
        resolution_requested: false,
        resolution_notes: ''
      }
    };
    console.log('[Resolution Cancel] editForm payload:', payload);

    this.pageBuilderService.editForm(payload, this.primaryId)
      .pipe(filter((result: any) => result))
      .subscribe({
        next: (_) => {
          this.closePopup();
          this.lastGridOperation = 'edit';
          this.updateLocalGridItem({
            resolution_requested: false,
            resolution_notes: ''
          }, this.primaryId);
          this.alertService.success('Resolution request cancelled successfully.');
        },
        error: (err) => {
          console.error('[Resolution Cancel] editForm error:', err);
          this.alertService.error('Failed to cancel resolution. Please try again.');
        }
      });
  }


  filterDefComments(data: any[]) : any[] {
    const realTimeUpdateDetails = [{
      pageId: 3630,
      PageName: 'Deficiency Comments'
    },
    {
      pageId: 3567,
      PageName: 'Verifiable Business and Industry Work Experience'
    },
    {
      pageId: 3568,
      PageName: 'Verifiable Teaching Experience'
    },
    {
      pageId: 3531,
      PageName: 'Out of State Licensure'
    },
    {
      pageId: 3519,
      PageName: 'License & Endorsements'
    },
      {
      pageId: 3512,
      PageName: 'Name History'
    },
    {
      pageId: 3516,
      PageName: 'Academic Background'
    },
    {
      pageId: 3517,
      PageName: 'Nevada Testing'
    },
    {
      pageId: 3520,
      PageName: 'Other Testing'
    }, {
      pageId: 3736,
      PageName: 'District / Charter Employment'
    },
    {
      pageId: 3737,
      PageName: 'Additional Professional Development'
    }
  ];
    const matchingDetails = realTimeUpdateDetails?.find(detail => detail.pageId == Number(this.gridId)) || realTimeUpdateDetails.find(detail => detail.pageId == Number(this.gridId));   
    if(matchingDetails) {
    const applicationTimeLine = this.formData?.applicationTimeLine;
    if(!applicationTimeLine || !Array.isArray(applicationTimeLine) || applicationTimeLine.length === 0){
      return data;
    } 
    const intakeStatusCount: number = applicationTimeLine?.filter(item => item?.cd_application_status === '18')?.length || 0;
    const recentIntakeStatusDate = Math.max(
      ...(
        applicationTimeLine
          ?.filter(item => item?.cd_application_status === '18')
          .map(item => new Date(item?.occurred_date.replace("T", " ")
          .replace("Z", "")).getTime()) ?? []
      )
    );  
    // const recentDeficienyStatusDate = Math.max(
    //   ...(
    //     applicationTimeLine
    //       ?.filter(item => item?.cd_application_status === '19')
    //       .map(item => new Date(item?.occurred_date.replace("T", " ")
    //       .replace("Z", "")).getTime()) ?? []
    //   )
    // );  
    // const recentStatusDate = Math.max(
    //   ...(
    //     applicationTimeLine
    //       ?.map(item => new Date(item?.occurred_date.replace("T", " ")
    //       .replace("Z", "")).getTime()) ?? []
    //   )
    // );  
    if(this.formData?.isApplicant === true){    
          if(this.formData?.isStaffDeficiencyStatus === true){ 
            if(intakeStatusCount === 1){
              if(matchingDetails.PageName === 'Deficiency Comments'){
                return [];
              }else{
               data.forEach(item => {
                    if (item.deficiency_status) {
                        item.deficiency_status = null;
                    }
                });
               return data;
              }
            }else if(intakeStatusCount > 1){
              if(matchingDetails.PageName === 'Deficiency Comments'){
                let filteredValue = data.filter(item => item?.notes_type === 'Deficiency' && item.created_date && new Date(item.created_date.replace("T", " ")
          .replace("Z", "")).getTime() <= recentIntakeStatusDate);
                filteredValue.map(item => {
                      if(new Date(item.updated_date).getTime() > recentIntakeStatusDate){
                            if(['Validated','Deficiency'].includes(item.review_status)) {
                                item.review_status = 'Addressed';
                             }                   
                      }
                });
                return filteredValue;
              }else {
                data.forEach(item => {
                    if (item.deficiency_status) {
                      if(new Date(item.deficiency_created_date.replace("T", " ")
          .replace("Z", "")).getTime() > recentIntakeStatusDate){
                        item.deficiency_status = null;
                      }
                      else if(new Date(item.deficiency_updated_date.replace("T", " ")
          .replace("Z", "")).getTime() > recentIntakeStatusDate){
                            if(['Validated','Deficiency'].includes(item.deficiency_status)) {
                                item.deficiency_status = 'Addressed';
                             }                   
                      }
                  }
                });
                return data;
              }
            }
          }
          // else if(this.formData?.isStaffDeficiencyStatus === false && this.formData?.isApplicantDeficiencyStatus === false && this.formData?.cd_application_status != '16'){ 
          //   if(matchingDetails.PageName === 'Deficiency Comments') {
          //       let filteredValue = data.filter(item => item?.notes_type === 'Deficiency' && item.created_date && new Date(item.created_date).getTime() <= recentStatusDate);
          //       filteredValue.map(item => {
          //         item.review_status = new Date(item.updated_date).getTime() >= recentStatusDate ? 'Pending Review' : item.review_status;
          //       });
          //       return filteredValue;
          //     }
          // }
         }
  }
   return data;
  }
}
